import type { IOffersSearchTab } from "./types";

export const OFFERS_SEARCH_TAB_IDS = [
  "flights",
  "hotels",
  "packages",
  "activities",
] as const;

export type OffersSearchTabId = (typeof OFFERS_SEARCH_TAB_IDS)[number];

export const DEFAULT_OFFERS_SEARCH_TABS_ES: IOffersSearchTab[] = [
  { id: "flights", label: "Vuelos" },
  { id: "hotels", label: "Hoteles" },
  { id: "packages", label: "Paquetes" },
  { id: "activities", label: "Actividades" },
];

export const DEFAULT_OFFERS_SEARCH_TABS_EN: IOffersSearchTab[] = [
  { id: "flights", label: "Flights" },
  { id: "hotels", label: "Hotels" },
  { id: "packages", label: "Packages" },
  { id: "activities", label: "Activities" },
];

export function resolveOffersSearchTabs(
  tabs: IOffersSearchTab[]
): IOffersSearchTab[] {
  const tabMap = new Map(tabs.map((tab) => [tab.id, tab]));

  return OFFERS_SEARCH_TAB_IDS.map((id) => {
    const existing = tabMap.get(id);
    if (existing) {
      return existing;
    }

    const fallback =
      DEFAULT_OFFERS_SEARCH_TABS_ES.find((tab) => tab.id === id) ??
      DEFAULT_OFFERS_SEARCH_TABS_EN.find((tab) => tab.id === id);

    return fallback ?? { id, label: id };
  });
}
